import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

const VerifyQueries = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    const token = searchParams.get("token");

    const resolveLink = async () => {
      if (!token) {
        navigate("/login");
        return;
      }

      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/api/auth/resolve-assignee-link`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ token }),
          }
        );
        const data = await response.json();

        if (!response.ok) {
          setError(data.message || "Invalid or expired link.");
          setTimeout(() => navigate("/login"), 3000);
          return;
        }

        if (data.redirectPath) {
          navigate(data.redirectPath);
        } else {
          navigate("/signup");
        }
      } catch {
        setError("Unable to process this link. Redirecting to login...");
        setTimeout(() => navigate("/login"), 3000);
      }
    };

    resolveLink();
  }, [searchParams, navigate]);

  return (
    <div className="flex h-screen w-screen items-center justify-center bg-gray-50 dark:bg-dark-900">
      <div className="flex flex-col items-center gap-4 max-w-md text-center px-6">
        {!error && (
          <div className="h-12 w-12 animate-spin rounded-full border-4 border-primary-500 border-t-transparent" />
        )}
        <p className="text-sm font-medium text-gray-600 dark:text-gray-400">
          {error || "Preparing your registration link, please wait..."}
        </p>
      </div>
    </div>
  );
};

export default VerifyQueries;
